::ng-deep particle-confirm-transmission-dialog ._container particle-transmission-form-editor-container{margin-bottom:20px}
/*# sourceMappingURL=confirm-transmission-dialog.component-BSSB3V65.css.map */
